import type { SYSTableDefIds } from "../../../../../../../_ovlclient/src"
import { html, ovl } from "../../../../../../../_ovlclient/src"
import { Data } from "../../../../../../../_ovlclient/src/dataapi"
import {
  FileGet,
  SortGet,
} from "../../../../../../../_ovlclient/src/global/globalapi"
import { DialogOkCancel } from "../../../../../../../_ovlclient/src/library/dialog/dialogapi"
import { FormHandlingType } from "../../../../../../../_ovlclient/src/library/dialog/sysdialogbase"
import {
  FormGet,
  FormIsValid,
} from "../../../../../../../_ovlclient/src/library/forms/formapi"
import { SYSBaseElement } from "../../../../../../../_ovlclient/src/library/sysbaseelement"
import { TableGet } from "../../../../../../../_ovlclient/src/library/table/tableapi"
import { N, T } from "../../../../../../../_ovlclient/src/textapi"
import { BPFilterFields } from "../../../components/bpfilter/formdef"
import { GotoDetailHelper } from "../../../features/qutoffering/offering/hookactions"
import { Offering } from "../../../features/qutoffering/offering/tabledef"
import { ResetDetailChanges } from "./details/helpers"
import { EditLocked, OpenTableUploadEdit } from "./helpers"

export class ScreenOfferingAdmin extends SYSBaseElement {
  offeringToolState: typeof this.state.app.features.QUTOffering
  offeringToolAdminState: typeof this.state.app.screens.QUTOffering
  async init() {
    this.offeringToolState = this.state.app.features.QUTOffering
    this.offeringToolAdminState = this.state.app.screens.QUTOffering
    await super.init()
  }
  openAdminUpload = async () => {
    await OpenTableUploadEdit()
  }

  openDetailOrResumeError = async (rowKey: string, error: string) => {
    if (error) {
      if ((await DialogOkCancel(T("QUTOfferingOfferingResume"))) === 1) {
        let row: Offering = TableGet("QUTOffering").rows[rowKey]
        let docEntry = row.DocEntry
        let status = row.U_ITF_PRT_OfferStatus

        if (
          rowKey === ovl.getState().app.features.QUTOffering.selectedOfferKey
        ) {
          ResetDetailChanges()
        }
        ovl.getActions().app.features.QUTOffering.actions.ShowOfferingProgress({
          docEntry,
          clearError: true,
        })
        try {
          await Data(
            "offering/resume",
            {
              docEntry,
              status,
            },
            { method: "GET" }
          )
        } finally {
        }
      }
    } else {
      await GotoDetailHelper(rowKey)
    }
  }

  async handleDocClick(e: Event) {
    e.preventDefault()
    e.stopPropagation()
    FileGet({
      cat: "OfferingToolDocPDF",
    })
  }

  getOfferCalcDetail = (t: number, allOfferTab, docEntry) => {
    let rowKey = allOfferTab.getKeys({
      byIdValue: t,
    })[0]
    let row = allOfferTab.rows[rowKey]
    let status = row["U_ITF_PRT_OfferStatus"]
    let error = row["U_ITF_PRT_OfferError"]

    let errorDisplay
    if (error) {
      errorDisplay = html`<div class="OfferingCalcCardSmallHintError">
        ${error}
      </div>`
    }

    let comments
    if (row.Comments !== row.U_ITF_PRT_FileName) {
      comments = html`<div class="OfferingCalcCardSmallHint">
        ${row.Comments}
      </div>`
    }
    let offerEntry = allOfferTab.rows[rowKey].DocEntry
    let isInProgress = status !== "Ready" && status !== "Accepted" && !error
    let progressBar
    if (isInProgress) {
      progressBar = html` <span
        class="fd-busy-indicator--s"
        aria-hidden="false"
        aria-label="Loading"
      >
        <div class="fd-busy-indicator--circle-0"></div>
        <div class="fd-busy-indicator--circle-1"></div>
        <div class="fd-busy-indicator--circle-2"></div>
      </span>`
    }
    return html`<div>
      <a
        href="#"
        id="ovllinked_${offerEntry}"
        @click=${(e) => {
          e.preventDefault()
          this.openDetailOrResumeError(rowKey, error)
        }}
        class="fd-link fd-link--emphasized"
        ><span
          class="fd-link__content OfferingCalcCardOfferLink ${error
            ? "__hasError"
            : ""}"
          >${t}</span
        ></a
      >&nbsp;${progressBar}<button
        @click=${async (e) => {
          if (
            (await DialogOkCancel(
              T("QUTOfferingOfferingAdminConfirmRemoveAssignment")
            )) === 2
          ) {
            return
          }

          await this.actions.app.features.QUTOffering.actions.LinkSalesCalc({
            docEntry,
            offerEntry,
            unLink: true,
          })
        }}
        class="fd-button fd-button--transparent fd-button--compact"
      >
        <i class="sap-icon--decline"></i>
      </button>
      <div class="OfferingCalcCardSmallHint">${row.U_ITF_PRT_FileName}</div>
      ${comments} ${errorDisplay}
    </div>`
  }
  async getUI() {
    let uploadDisabled = EditLocked()

    let uploadHtml = html`
      <div class="fd-file-uploader offering-uploader">
        <button
          ?disabled=${uploadDisabled ||
          !FormIsValid(FormGet("QUTBPFilter").formState)}
          @click=${() => this.openAdminUpload()}
          id="asset_browse_button1"
          class="fd-button"
          aria-label="file auswählen"
        >
          <span class="fd-button__text"
            >${T("QUTOfferingOfferingNewOffer")}</span
          >
          <i class="sap-icon--upload"></i>
        </button>
      </div>
    `
    let calcOrders

    let allOfferTab = TableGet("QUTOffering")

    // using spread operator here becaus elsewise we would modify array and retrigger rendering (endless)
    // this issue we should tackele in a new tracking - rewrite of the base. possible goal should be that no rendering code triggers an update
    let sortedCalcOrderRows =
      this.state.app.features.QUTOffering.adminSalesCalcResult.sort((a, b) => {
        let res = SortGet(b.DocStatus === "O", a.DocStatus === "O")
        if (res === 0) {
          res = SortGet(b.DocNum, a.DocNum)
        }
        return res
      })

    calcOrders = html` <h4 class="fd-layout-panel__title OfferingCalcTitle">
        ${T("QUTOfferingOfferingAdminCalcOrder")}
      </h4>
      <div class="OfferingCalcGrid">
        ${sortedCalcOrderRows.map(
          (m) =>
            html`<div
              @dragover=${(e: DragEvent) => {
                e.dataTransfer.dropEffect = "link"
                e.preventDefault()
              }}
              @drop=${async (e: DragEvent) => {
                let key = e.dataTransfer.getData("plain/text")
                let offerEntry = allOfferTab?.rows?.[key]?.DocEntry
                if (!offerEntry) {
                  return
                }
                let docEntry = m.DocEntry
                await this.actions.app.features.QUTOffering.actions.LinkSalesCalc(
                  { docEntry, offerEntry, unLink: false }
                )
              }}
              class="fd-card fd-card--object OfferingCalcCard __docStatus${m.DocStatus}"
              role="region"
            >
              <div class="fd-card__header">
                <div class="fd-card__header-text">
                  <div class="fd-card__title-area">
                    <a
                      href="#"
                      title="SAP"
                      @click=${(e) => {
                        e.preventDefault()
                        Data("offering/b1linkopener", {
                          objectType: "17",
                          id: m.DocEntry.toString(),
                        })
                      }}
                      class="fd-card__title fd-link"
                      >Nr: ${m.DocNum}</a
                    >
                  </div>
                  <div class="fd-card__subtitle-area">
                    <div class="fd-card__subtitle">${m.Comments}</div>
                  </div>
                </div>
              </div>
              <div class="fd-card__content __2cols">
                <div>
                  <div>Soll</div>
                  ${m.TargetOffers.map((t) =>
                    this.getOfferCalcDetail(t, allOfferTab, m.DocEntry)
                  )}
                </div>
                <div>
                  <div>Ist</div>
                  ${m.ActualOffers.map((t) =>
                    this.getOfferCalcDetail(t, allOfferTab, m.DocEntry)
                  )}
                </div>

                <div class="OfferingCalcCardSummary">
                  ${m.TargetSummaryPos}Pos &nbsp;${m.TargetSummaryQuantity}Stk
                  &nbsp;${N(m.TargetSummaryM1)}m1 &nbsp;
                  ${N(m.TargetSummaryM3)}m3
                </div>
                <div class="OfferingCalcCardSummary">
                  ${m.ActualSummaryPos}Pos &nbsp;${m.ActualSummaryQuantity}Stk
                  &nbsp;${N(m.ActualSummaryM1)}m1 &nbsp;
                  ${N(m.ActualSummaryM3)}m3
                </div>
              </div>
            </div>`
        )}
      </div>`
    BPFilterFields.CardCode.value = this.state.ovl.user.cardCode
    return html`
      <div class="ovl-smart-padding-lr-fullwidth ovl-smart-screen-margins">
        <div class="fd-layout-panel ">
          <div class="fd-layout-panel__header">
            <div class="fd-layout-panel__head">
              <h3 class="fd-layout-panel__title">
                <b>${T("QUTOfferingOfferingAdmin")}</b>
              </h3>
            </div>
            <div class="fd-layout-panel__actions">
              <h4 class="fd-layout-panel__title">
                ${T("QUTOfferingOfferingAdminSelectCustomer")}
              </h4>
              <comp-genbpfilter
                .formHandling=${<FormHandlingType>{
                  formType: "QUTBPFilter",
                  autoInit: true,
                  creation: {
                    autoInitFormFields: BPFilterFields,
                  },
                }}
              ></comp-genbpfilter>
              ${uploadHtml}
            </div>
          </div>

          <div class="fd-layout-panel__body">
            <div class="fd-icon-tab-bar">
              <ul
                role="tablist"
                class="fd-icon-tab-bar__header"
                @click=${(e) => {
                  let id = e.target.id
                  if (!id) {
                    id = (<HTMLElement>e.target).firstElementChild.id
                  }
                  if (id === "actual" || id === "target") {
                    this.offeringToolAdminState.activeTab = id
                  }
                }}
              >
                <li role="presentation" class="fd-icon-tab-bar__item">
                  <a
                    role="tab"
                    class="fd-icon-tab-bar__tab"
                    aria-selected="${this.offeringToolAdminState.activeTab ===
                    "target"}"
                  >
                    <span
                      class="fd-icon-tab-bar__tag fd-layout-panel__title"
                      id="target"
                    >
                      ${T("QUTOfferingOfferingTargetOffer")}
                    </span>
                  </a>
                </li>
                <li role="presentation" class="fd-icon-tab-bar__item">
                  <a
                    role="tab"
                    class="fd-icon-tab-bar__tab"
                    aria-selected="${this.offeringToolAdminState.activeTab ===
                    "actual"}"
                  >
                    <span
                      class="fd-icon-tab-bar__tag fd-layout-panel__title"
                      id="actual"
                      >${T("QUTOfferingOfferingActualOffer")}</span
                    >
                  </a>
                </li>
              </ul>
              ${this.offeringToolAdminState.activeTab === "target"
                ? html` <section
                    role="tabpanel"
                    class="fd-icon-tab-bar__panel"
                    id="target"
                    aria-labelledby="tab1"
                  >
                    <ovl-table
                      class="fd-table offering-table"
                      .props=${() => <SYSTableDefIds>"QUTOffering"}
                    >
                    </ovl-table>
                  </section>`
                : null}
              ${this.offeringToolAdminState.activeTab === "actual"
                ? html` <section
                    role="tabpanel"
                    class="fd-icon-tab-bar__panel"
                    id="actual"
                    aria-labelledby="tab2"
                  >
                    <ovl-table
                      class="fd-table offering-table"
                      .props=${() => <SYSTableDefIds>"QUTOfferingActual"}
                    >
                    </ovl-table>
                  </section>`
                : null}
            </div>
            ${calcOrders}
          </div>
        </div>
      </div>
    `
  }
}
